import { h } from 'preact'
import dayjs from 'dayjs'
import { useStateValue } from '../../state-management/store'
import { BookingStep } from '../../models/enums'
import { StepBody } from '../step-body'
import { SelfSchedulerFooter } from '../self-scheduler-footer'
import { calendarIcon } from '../../shared/svgIcons'
import { APPOINTMENT_TIME_FORMAT, APPOINTMENT_DATE_FORMAT } from '../../shared/const'
import removeDatetimeOffset from '../../shared/removeDatetimeOffset'
import * as style from './style.css'

const ValidationScreen: preact.FunctionalComponent = () => {
    const [{ selectedAppointmentTime, locations, selectedLocationId }] = useStateValue()

    const location = locations.find((locationItem) => locationItem.id === selectedLocationId)
    const datetimeWithoutOffset = removeDatetimeOffset(selectedAppointmentTime)

    const nextLabel = (
        <div>
            <span class={style.validationScreenConfirmButtonSmall}>CONFIRM ›</span>
            <span class={style.validationScreenConfirmButtonLarge}>BOOK APPOINTMENT ›</span>
        </div>
    )

    return (
        <section class={style.validationScreenContainer}>
            <StepBody>
                <div class={style.validationScreen}>
                    <h3 class={style.validationScreenTitle}>
                        We’re about to schedule your appointment. Please review the details:
                    </h3>
                    <div class={style.validationScreenIcon}>{calendarIcon()}</div>
                    <div class={style.validationScreenDatetime}>
                        {dayjs(datetimeWithoutOffset).format(APPOINTMENT_DATE_FORMAT)}
                        <br />
                        {dayjs(datetimeWithoutOffset).format(APPOINTMENT_TIME_FORMAT)}
                    </div>
                    {location !== undefined && (
                        <div class={style.validationScreenAddress}>
                            {location.name}
                            <br />
                            {`
                                ${location?.street ?? ''}
                                ${' '} 
                                ${location?.street2 ?? ''}
                                ${' '}
                                ${location.unit ? `, ${location.unit}` : ''}
                            `}
                            <br />
                            {`
                                ${location.city ? `${location.city}, ` : ''}
                                ${location?.state ?? ''}
                                ${' '}
                                ${location?.zip ?? ''}
                            `}
                        </div>
                    )}
                </div>
            </StepBody>
            <SelfSchedulerFooter
                nextStep={BookingStep.RESERVING}
                nextLabel={nextLabel}
                backStep={BookingStep.DATETIME}
            />
        </section>
    )
}

export default ValidationScreen
